import axios from 'axios';
import {
  USER_LOADED_CLIENT, AUTH_ERROR_CLIENT, LOGIN_SUCCESS_CLIENT, LOGIN_FAIL_CLIENT,
  LOGOUT_CLIENT, GET_USER 
} from './types';

import setAuthToken from '../utils/setAuthToken';

// Instancia de axios para Google
const googleAxios = axios.create({
  baseURL: 'https://www.googleapis.com',
});

//Load user (aquí se examina si el token es válido y se carga el usuario) (2025)
export const loadUserClient = () => async dispatch => {
  const backendAxios = setAuthToken(localStorage.token);

  try {
    const res = await backendAxios.get(`/api/auth/client`);

    await dispatch({
      type: USER_LOADED_CLIENT,
      payload: res.data
    });
    await dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.error(err.message, "Error loading user (auth.js)");
    dispatch({
      type: AUTH_ERROR_CLIENT
    });
  }
}

//Login user redes sociales (2025)
export const loginRed = data => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  try {
    const backendAxios = setAuthToken(localStorage.token);
    const res = await backendAxios.post(`/api/auth/client/goog_face`, data, config);

    dispatch({
      type: LOGIN_SUCCESS_CLIENT,
      payload: res.data
    });

    await dispatch(loadUserClient())
  } catch (err) {
    const errors = err.response.data.errors;

    dispatch({
      type: LOGIN_FAIL_CLIENT,
      payload: errors
    });
  }
}

//Login user (2025)
export const login = (email, password) => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const body = JSON.stringify({ email, password });

  try {
    const backendAxios = setAuthToken(localStorage.token);
    const res = await backendAxios.post(`/api/auth/client`, body, config);

    dispatch({
      type: LOGIN_SUCCESS_CLIENT,
      payload: res.data
    });

    await dispatch(loadUserClient())
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: LOGIN_FAIL_CLIENT,
      payload: errors
    });
  }
}

//Logout (2025)
export const logout = () => async dispatch => {
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    try {
      // Revocar el access_token de Google (opcional)
        await googleAxios.post('/oauth2/revoke', { token: accessToken }, {
        headers: {
          'Content-Type': 'application/json',
        },});
        console.log('Token de Google revocado');
    }
    catch (error) {
      console.error('Error al revocar el token de Google:', error);
    }
  }
  localStorage.removeItem('access_token');
  dispatch({
    type: LOGOUT_CLIENT
  });
  window.location.replace('/home');
}
